/**
 * Publisher-side per-network labels + accessible badge palette.
 *
 * Both maps are only meaningful for publishers admin has flipped
 * `disclose_networks` ON for — for everyone else the upstream feed
 * is opaque, and the BrandRow renders without a NetworkBadge.
 */
export const NETWORK_LABELS = {
  impact: "Impact",
  skimlinks: "Skimlinks",
  mrge: "Mrge",
  partnerize: "Partnerize",
  yieldkit: "Yieldkit",
  shopnomix: "Shopnomix",
  cj: "CJ",
  admedia: "AdMedia",
  pubadhub: "PubAdHub",
  pubadhub_kevin: "PubAdHub 2",
  shopnomix_kevin: "Shopnomix InMobi",
  flexoffers: "FlexOffers",
  siteplug: "Siteplug",
  maxbounty: "MaxBounty",
  cashbackhive: "CashbackHive",
  pronomix: "Pronomix",
  giddyup: "GiddyUp",
  rga: "ReallyGreatAds",
};

// Distinct, WCAG-AA-at-this-size badge palette — one fixed bg +
// matching dark text per network so the eye picks up the feed at a
// glance without competing with the brand name.
export const NETWORK_BADGE = {
  impact:     "bg-violet-100 text-violet-800 border-violet-200",
  skimlinks:  "bg-emerald-100 text-emerald-800 border-emerald-200",
  mrge:       "bg-orange-100 text-orange-800 border-orange-200",
  partnerize: "bg-blue-100 text-blue-800 border-blue-200",
  yieldkit:   "bg-rose-100 text-rose-800 border-rose-200",
  shopnomix:  "bg-amber-100 text-amber-800 border-amber-200",
  cj:         "bg-cyan-100 text-cyan-800 border-cyan-200",
  admedia:    "bg-pink-100 text-pink-800 border-pink-200",
  pubadhub:   "bg-teal-100 text-teal-800 border-teal-200",
  pubadhub_kevin: "bg-lime-100 text-lime-800 border-lime-200",
  shopnomix_kevin: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
  flexoffers: "bg-indigo-100 text-indigo-800 border-indigo-200",
  siteplug:   "bg-sky-100 text-sky-800 border-sky-200",
  maxbounty:  "bg-cyan-100 text-cyan-800 border-cyan-200",
  cashbackhive:  "bg-teal-100 text-teal-800 border-teal-200",
  pronomix:   "bg-purple-100 text-purple-800 border-purple-200",
  giddyup:    "bg-yellow-100 text-yellow-800 border-yellow-200",
  rga:        "bg-red-100 text-red-800 border-red-200",
};

// Server page size for My Brands. First paint + each "Show more" fetch
// this many hydrated rows. Empirically ~100 fills 1.5 screens.
export const PAGE_SIZE = 100;

